import { useMemo, useState } from 'react'
import placeholder from '../../../../assets/placeholder_artist.jpg'
import { Box, Skeleton } from '@mui/material'
import { Link } from 'react-router-dom'
import AlbumFocusHover from './AlbumFocusHover'

var albumItem = {
    width: '100%',
    borderRadius: '16px',
    overflow: 'hidden',
    position: 'relative',
    '&:hover .albumInfos': {
        animation: 'fadeIn .3s',
        opacity: 1
    }
}

interface AlbumsFocusProps {
    discoverData: any
}

const AlbumsFocus = ({ discoverData }: AlbumsFocusProps) => {

    var [currentIndex, setCurrentIndex] = useState(0) 

    const albums = useMemo(() => {
        if (discoverData === null)
            return []

        let dayRanks = discoverData?.rankings
        var producers_ids: any = []
        var allProducers: any = []
        for (const rank of dayRanks) {
            if (rank.track.album && rank.track.album._id) {
                if (![...allProducers].map((alb: any) => alb._id).includes(rank.track.album._id)) 
                    allProducers.push(rank.track.album)
                producers_ids[rank.track.album._id] = (producers_ids[rank.track.album._id] || 0) + 1                    
            }
        }

        var items = Object.keys(producers_ids).map(function(key) { return [key, producers_ids[key]] })
        items.sort(function(a, b) { return b[1] - a[1] })
        setCurrentIndex(0)
        return allProducers.sort((a: any, b: any) => items.map((item: any) => item[0]).indexOf(a._id) - items.map((item: any) => item[0]).indexOf(b._id)).map((prod: any, i: number) => {
            return {
                ...prod,
                topTrackCount: items[i][1]
            }
        })
    }, [discoverData])

    return albums && albums.length > 0
    ?
        <Box sx={albumItem} >
            <AlbumFocusHover albums={albums} currentIndex={currentIndex} action={setCurrentIndex} />
            <Link to={`/album/${albums[currentIndex]?._id}`}>
                <img 
                    className="image-cover"
                    width={'100%'}
                    height={'100%'}
                    src={albums[currentIndex]?.apple_artwork_url ? albums[currentIndex]?.apple_artwork_url.replace("{w}","1200").replace("{h}","800") : placeholder} 
                    alt={albums[currentIndex]?.apple_name} />
            </Link>
        </Box>
    :
        <Skeleton variant="rectangular" width={'50%'} height={'100%'} sx={{bgcolor: '#00000088'}} />

}

export default AlbumsFocus